export const isProduction = () => window._env_?.REACT_APP_IS_PRODUCTION === "true";

export const logIfDev = (...args: any[]) => {
  if (!isProduction()) console.log(...args);
};
